export default "__VITE_ASSET__CVWYOgV3__"